export default {
  name: 'TError403',
  title: ({ title }) => title,
  data () {
    return {
      title: this.$tc('Error403')
    }
  }
}
